import {
  Button,
  Modal,
  Form,
  Input,
  Flex,
  Typography,
  message,
  Select,
  Row,
  Col,
} from "antd";
import React, {
  forwardRef,
  useState,
  useImperativeHandle,
  useRef,
} from "react";
import { EditOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import UploadFile from "@/components/UplaodFileVideo";
const UpdateModal = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const contractsRef = useRef();
  const { record: updateModalRef, onSuccess } = props;
  const { Option } = Select;
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [editable, setEditable] = useState(false);
  const [appFileList, setAppFileList] = useState([]);

  useImperativeHandle(ref, () => ({
    openModal: async (record) => {
      try {
        setVisible(true);
        console.log("record", record);
        form.setFieldsValue({
          id: record.id,
          title: record.title,
          content: record.content,
          sourceRemark: record.sourceRemark,
          type: record.type,
          url: record.url,
          fileUrlList: record.fileUrlList,
        });
        const defaultFiles = (record.fileUrlList || []).map((f, index) => ({
          uid: String(index),
          name: f.fileUrl.split("/").pop(), // 文件名
          status: "done",
          url: f.fileUrl,
          type: f.contentType,
        }));

        setAppFileList(defaultFiles);
      } catch (error) {
        message.error("Failed to fetch user data");
      } finally {
        setLoading(false);
      }
    },
  }));

  async function uploadFiles(data, fieldType) {
    const files = [];

    for (const item of data) {
      const formData = new FormData();
      formData.append("files", item.originFileObj);
      formData.append("type", fieldType);

      try {
        setLoading(true);
        const response = await http.post(`${api.getAppAdUpload}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (response.code === "1") {
          files.push(...response.data);
        }
      } catch (error) {
        console.error("上传出错:", error);
        throw error;
      } finally {
        setLoading(false);
      }
    }
    return files;
  }

  // 修改用户信息提交
  const onFinishAdd = async (values) => {
    try {
      setLoading(true);

      // 处理文件：已有的直接取 url，新上传的要先上传
      const finalFiles = [];
      for (const file of appFileList) {
        if (file.originFileObj) {
          // 新文件 -> 上传
          const uploaded = await uploadFiles([file]);
          finalFiles.push(...uploaded);
        } else {
          // 已有文件 -> 保留
          finalFiles.push({
            fileUrl: file.url,
            contentType: file.type,
          });
        }
      }

      const queryParams = {
        ...values,
        newFileList: finalFiles,
      };

      const response = await http.post(
        `${api.AppAdvertisingUpdate}`,
        queryParams
      );
      if (response.code === "1") {
        message.success("Save successfully");
        setVisible(false);
        form.resetFields();
        onSuccess?.();
      } else {
        message.error(response.msg || "Save failed");
      }
    } catch (error) {
      message.error("Submit error");
    } finally {
      setLoading(false);
    }
  };

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Typography.Title level={4} className="mg">
            MODIFY ADVERTISING
          </Typography.Title>
        </Flex>
      }
      width="50%"
      open={visible}
      onCancel={() => {
        setVisible(false);
        form.resetFields();
        setEditable(false);
      }}
      footer={[
        <Button
          key="back"
          onClick={() => {
            setVisible(false);
            form.resetFields();
            setEditable(false);
          }}
        >
          Cancel
        </Button>,

        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={() => form.submit()}
          disabled={loading}
        >
          Submit
        </Button>,
      ]}
      destroyOnClose
    >
      <Flex justify="space-between" align="flex-start">
        <div className="model_top" style={{ width: "100%", height: "80%" }}>
          <div
            style={{
              marginBottom: "16px",
              fontWeight: "bold",
              fontSize: "20px",
              marginLeft: "20px",
            }}
          >
            Advertising Info
          </div>
          <div className="model_content">
            <Form
              {...layout}
              name="passwordResetForm"
              onFinish={onFinishAdd}
              form={form}
              labelCol={{
                style: {
                  width: "150px",
                },
              }}
              wrapperCol={{
                style: {
                  flex: 1,
                },
              }}
            >
              <Form.Item
                name="type"
                label="Advertising Type"
                rules={[
                  {
                    required: true,
                    message: "Please select Advertising Type.",
                  },
                ]}
              >
                <Select placeholder="Please select Advertising Type" allowClear>
                  <Option value="carousel">Carousel</Option>
                  <Option value="text">Text</Option>
                </Select>
              </Form.Item>
              <Form.Item
                name="title"
                label="Advertising Title"
                rules={[
                  { required: true, message: "Please enter title." },
                  { max: 50, message: "Title cannot exceed 50 characters." },
                ]}
              >
                <Input
                  placeholder="Please enter title."
                  allowClear
                  maxLength={50}
                  showCount
                />
              </Form.Item>

              <Form.Item
                name="content"
                label="Contents"
                rules={[
                  { required: true, message: "Please enter contents." },
                  {
                    max: 200,
                    message: "Contents cannot exceed 200 characters.",
                  },
                ]}
              >
                <Input.TextArea
                  placeholder="Please enter contents."
                  allowClear
                  maxLength={200}
                  showCount
                  autoSize={{ minRows: 3, maxRows: 6 }}
                />
              </Form.Item>

              <Form.Item name="url" label="Url">
                <Input placeholder="Please enter url." allowClear />
              </Form.Item>

              <Form.Item name="sourceRemark" label="Remark">
                <Input placeholder="Please enter remark." allowClear />
              </Form.Item>

              <Form.Item name="fileList" label="Picture or video">
                <UploadFile
                  ref={contractsRef}
                  sendDataToParent={(files) => setAppFileList(files)}
                  accept=".pdf,.jpg,.png,.mp4"
                  multiple
                  defaultFileList={appFileList}
                />
              </Form.Item>

              <Form.Item name="fileUrlList" noStyle>
                <Input type="hidden" />
              </Form.Item>
              <Form.Item name="id" noStyle>
                <Input type="hidden" />
              </Form.Item>
            </Form>
          </div>
        </div>
      </Flex>
    </Modal>
  );
});

export default UpdateModal;
